/* ============================================================
 * cover-product.js  —  v3
 * Fixes: variant active styles applied inline (bypasses theme CSS)
 *        · photo preview shown/hidden via style.display (bypasses CSS)
 *        · CVR_CONFIG read lazily inside functions
 * ============================================================ */
(function () {
  'use strict';

  /* Read config lazily so it's always up-to-date when functions run */
  function cfg() {
    return window.CVR_CONFIG || { maxMb: 10, requirePhoto: true, variants: [] };
  }

  document.addEventListener('DOMContentLoaded', init);
  if (document.readyState !== 'loading') init();

  var _ready = false;
  function init() {
    if (_ready) return;
    _ready = true;
    try { initGallery();   } catch(e) { console.warn('[cover] gallery:', e); }
    try { initVariants();  } catch(e) { console.warn('[cover] variants:', e); }
    try { initUpload();    } catch(e) { console.warn('[cover] upload:', e); }
    try { initQty();       } catch(e) { console.warn('[cover] qty:', e); }
    try { initBuyNow();    } catch(e) { console.warn('[cover] buynow:', e); }
    try { initForm();      } catch(e) { console.warn('[cover] form:', e); }
  }

  /* ============================================================
   *  GALLERY
   * ============================================================ */
  function initGallery() {
    var mainImg = document.getElementById('cvr-main-img');
    var thumbs  = document.querySelectorAll('.cvr-thumb');
    if (!mainImg || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.dataset.src;
        if (!src) return;
        mainImg.style.opacity = '0';
        setTimeout(function () {
          mainImg.src = src;
          mainImg.style.opacity = '1';
        }, 120);
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
      });
    });
  }

  /* ============================================================
   *  VARIANTS
   *  Applies active styles DIRECTLY on the element (inline)
   *  so the theme's CSS cannot override them.
   * ============================================================ */
  var selectedOptions = [];

  /* Styles applied when a button IS active */
  var ACTIVE_STYLE   = { background: '#1a1a1a', color: '#ffffff', borderColor: '#1a1a1a', outline: '2px solid #1a1a1a', outlineOffset: '2px' };
  /* Styles reset when a button is NOT active */
  var INACTIVE_STYLE = { background: '',        color: '',        borderColor: '',        outline: '',                   outlineOffset: ''    };

  function applyBtnStyle(btn, styles) {
    Object.keys(styles).forEach(function (prop) {
      btn.style[prop] = styles[prop];
    });
  }

  function initVariants() {
    var groups = document.querySelectorAll('.cvr-variant-group');
    if (!groups.length) return;

    /* Seed from first active button in each group */
    groups.forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex || '0', 10);
      var active = group.querySelector('.cvr-variant-btn.active');
      selectedOptions[idx] = active ? active.dataset.value : '';
      /* Apply active style to the pre-selected button */
      if (active) applyBtnStyle(active, ACTIVE_STYLE);
    });

    document.querySelectorAll('.cvr-variant-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx   = parseInt(btn.dataset.optionIndex || '0', 10);
        var group = btn.closest('.cvr-variant-group');
        if (!group) return;

        /* Reset all buttons in this group */
        group.querySelectorAll('.cvr-variant-btn').forEach(function (b) {
          b.classList.remove('active');
          applyBtnStyle(b, INACTIVE_STYLE);
        });

        /* Activate clicked button */
        btn.classList.add('active');
        applyBtnStyle(btn, ACTIVE_STYLE);

        selectedOptions[idx] = btn.dataset.value;
        updateVariant();
      });
    });

    updateVariant();
  }

  function findVariant() {
    var variants = cfg().variants || [];
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (selectedOptions[j] !== undefined &&
            selectedOptions[j] !== '' &&
            v['option' + (j + 1)] !== selectedOptions[j]) {
          ok = false;
          break;
        }
      }
      if (ok) return v;
    }
    return null;
  }

  function updateVariant() {
    var matched      = findVariant();
    var variantInput = document.getElementById('cvr-variant-id');
    var submitBtn    = document.getElementById('cvr-submit-btn');
    var cartPrice    = document.getElementById('cvr-cart-price');
    var qty          = parseInt((document.getElementById('cvr-qty-value') || {}).textContent || '1', 10);

    if (!matched) {
      if (submitBtn) submitBtn.disabled = true;
      return;
    }

    if (variantInput) variantInput.value = String(matched.id);
    if (submitBtn)    submitBtn.dataset.unitPrice = String(matched.price);
    if (submitBtn)    submitBtn.disabled = !matched.available;

    if (cartPrice) {
      cartPrice.textContent = formatMoney(matched.price * qty);
    }

    var buyBtn = document.getElementById('cvr-buy-now-btn');
    if (buyBtn) buyBtn.dataset.unitPrice = String(matched.price);
  }

  /* ============================================================
   *  PHOTO UPLOAD
   *  Preview shown/hidden via style.display directly — not via
   *  CSS class alone — so theme styles cannot override it.
   * ============================================================ */
  var uploadedFile = null;

  function initUpload() {
    var fileInput  = document.getElementById('cvr-file-input');
    var uploadBox  = document.getElementById('cvr-upload-box');
    var changeBtn  = document.getElementById('cvr-change-btn');
    var errorEl    = document.getElementById('cvr-upload-error');
    var emptyEl    = uploadBox ? uploadBox.querySelector('.cvr-upload-empty')   : null;
    var previewEl  = document.getElementById('cvr-upload-preview');

    if (!fileInput) return;

    /* Validate + preview when a file is selected */
    fileInput.addEventListener('change', function () {
      clearUploadError();
      var file = fileInput.files[0];
      if (!file) return;

      var validTypes = ['image/jpeg', 'image/png', 'image/webp'];
      if (validTypes.indexOf(file.type) === -1) {
        showUploadError('Only JPG, PNG or WEBP images are allowed.');
        fileInput.value = '';
        return;
      }
      var maxBytes = (cfg().maxMb || 10) * 1024 * 1024;
      if (file.size > maxBytes) {
        showUploadError('Photo exceeds the ' + (cfg().maxMb || 10) + ' MB limit. Please upload a smaller file.');
        fileInput.value = '';
        return;
      }

      uploadedFile = file;
      showPreview(file);
    });

    /* Drag & drop */
    if (uploadBox) {
      uploadBox.addEventListener('dragover', function (e) {
        e.preventDefault();
        uploadBox.classList.add('drag-over');
      });
      uploadBox.addEventListener('dragleave', function () {
        uploadBox.classList.remove('drag-over');
      });
      uploadBox.addEventListener('drop', function (e) {
        e.preventDefault();
        uploadBox.classList.remove('drag-over');
        var file = e.dataTransfer && e.dataTransfer.files[0];
        if (!file) return;
        try {
          var dt = new DataTransfer();
          dt.items.add(file);
          fileInput.files = dt.files;
          fileInput.dispatchEvent(new Event('change'));
        } catch(err) {
          fileInput.click();
        }
      });
    }

    /* "Change photo" button clears state */
    if (changeBtn) {
      changeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        fileInput.value = '';
        uploadedFile = null;
        /* Hide preview, show empty state */
        if (uploadBox)  uploadBox.classList.remove('has-file');
        if (emptyEl)    emptyEl.style.display   = '';
        if (previewEl)  previewEl.style.display  = 'none';
        clearUploadError();
      });
    }

    function showPreview(file) {
      var thumb  = document.getElementById('cvr-preview-thumb');
      var nameEl = document.getElementById('cvr-preview-name');
      var sizeEl = document.getElementById('cvr-preview-size');

      /* Read file as data URL for thumbnail */
      var reader = new FileReader();
      reader.onload = function (ev) {
        if (thumb) {
          thumb.src = ev.target.result;
          thumb.style.display = 'block';
        }
      };
      reader.readAsDataURL(file);

      if (nameEl) nameEl.textContent = file.name;
      if (sizeEl) sizeEl.textContent = formatBytes(file.size);

      /* Show preview, hide empty state — directly via style */
      if (uploadBox) uploadBox.classList.add('has-file');
      if (emptyEl)   emptyEl.style.display  = 'none';
      if (previewEl) previewEl.style.display = 'flex';
    }

    function showUploadError(msg) {
      if (errorEl) { errorEl.textContent = msg; errorEl.style.display = 'block'; }
    }
    function clearUploadError() {
      if (errorEl) { errorEl.textContent = ''; errorEl.style.display = ''; }
    }
  }

  /* ============================================================
   *  QUANTITY
   * ============================================================ */
  function initQty() {
    var minusBtn = document.getElementById('cvr-qty-minus');
    var plusBtn  = document.getElementById('cvr-qty-plus');
    var qtyVal   = document.getElementById('cvr-qty-value');
    var qtyInput = document.getElementById('cvr-qty-input');
    if (!qtyVal) return;

    function setQty(v) {
      v = Math.max(1, Math.min(99, v));
      qtyVal.textContent = String(v);
      if (qtyInput) qtyInput.value = String(v);
      updatePrices(v);
    }

    if (minusBtn) minusBtn.addEventListener('click', function () {
      setQty(parseInt(qtyVal.textContent, 10) - 1);
    });
    if (plusBtn) plusBtn.addEventListener('click', function () {
      setQty(parseInt(qtyVal.textContent, 10) + 1);
    });

    updatePrices(parseInt(qtyVal.textContent, 10) || 1);
  }

  function updatePrices(qty) {
    var cartPrice = document.getElementById('cvr-cart-price');
    var submitBtn = document.getElementById('cvr-submit-btn');
    if (!cartPrice || !submitBtn) return;
    var unit = parseInt(submitBtn.dataset.unitPrice || '0', 10);
    if (!isNaN(unit) && unit > 0) {
      cartPrice.textContent = formatMoney(unit * qty);
    }
  }

  /* ============================================================
   *  BUY NOW
   * ============================================================ */
  function initBuyNow() {
    var buyBtn = document.getElementById('cvr-buy-now-btn');
    if (!buyBtn) return;
    buyBtn.addEventListener('click', function () {
      var form = document.getElementById('cvr-form');
      if (!form) return;
      var ret = form.querySelector('input[name="return_to"]');
      if (!ret) {
        ret = document.createElement('input');
        ret.type = 'hidden';
        ret.name = 'return_to';
        form.appendChild(ret);
      }
      ret.value = '/checkout';
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        form.submit();
      }
    });
  }

  /* ============================================================
   *  FORM SUBMIT GUARD
   * ============================================================ */
  function initForm() {
    var form      = document.getElementById('cvr-form');
    var submitBtn = document.getElementById('cvr-submit-btn');
    var errorEl   = document.getElementById('cvr-upload-error');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      if (cfg().requirePhoto && !uploadedFile) {
        e.preventDefault();
        if (errorEl) {
          errorEl.textContent = 'Please upload a photo before adding to cart.';
          errorEl.style.display = 'block';
        }
        var box = document.getElementById('cvr-upload-box');
        if (box) box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      /* Write metadata */
      var propsEl = document.getElementById('cvr-props-data');
      if (propsEl) {
        var modelBtn = document.querySelector('.cvr-variant-btn.active');
        propsEl.value = JSON.stringify({
          model:    modelBtn ? modelBtn.dataset.value : '',
          filename: uploadedFile ? uploadedFile.name : ''
        });
      }

      if (submitBtn) {
        submitBtn.disabled = true;
        var cartPrice = document.getElementById('cvr-cart-price');
        submitBtn.textContent = 'Adding to cart…';
        if (cartPrice) submitBtn.appendChild(cartPrice);
      }
    });
  }

  /* ============================================================
   *  HELPERS
   * ============================================================ */
  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function formatBytes(bytes) {
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(0) + ' KB';
    return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
  }

})();
